import type { TDocumentDefinitions } from 'pdfmake/interfaces';

type BrowserPdfMake = {
  addVirtualFileSystem: (virtualFileSystem: Record<string, string>) => void;
  createPdf: (definition: TDocumentDefinitions) => { getBlob: () => Promise<Blob> };
};

let virtualFileSystemRegistered = false;
let pdfMakePromise: Promise<BrowserPdfMake> | null = null;

const loadPdfMake = async (): Promise<BrowserPdfMake> => {
  if (!pdfMakePromise) {
    pdfMakePromise = Promise.all([
      import('pdfmake/build/pdfmake'),
      import('pdfmake/build/vfs_fonts'),
    ]).then(([pdfMakeModule, pdfFontsModule]) => {
      const pdfMakeValue = (pdfMakeModule as unknown as { default?: unknown }).default || pdfMakeModule;
      const pdfFontsValue = (pdfFontsModule as unknown as { default?: unknown }).default || pdfFontsModule;
      const browserPdfMake = pdfMakeValue as BrowserPdfMake;
      if (!virtualFileSystemRegistered) {
        browserPdfMake.addVirtualFileSystem(pdfFontsValue as Record<string, string>);
        virtualFileSystemRegistered = true;
      }
      return browserPdfMake;
    });
  }
  return pdfMakePromise;
};

export const createCustomerDebtPdf = async (definition: TDocumentDefinitions): Promise<Blob> => {
  const browserPdfMake = await loadPdfMake();
  return browserPdfMake.createPdf(definition).getBlob();
};
